import axios from 'axios';
import _ from 'lodash';

import cfg from '../config';

export const DATA_GET_DATA = "data/GET_data";

export const DATA_SET_DETAILS = "data/SET_details";
export const DATA_RESET_DETAILS = "data/RESET_details";

const initialState = {
  data: [],
  details: null,
  timestamp: Date.now()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DATA_GET_DATA:
      return {
        ...state,
        data: _.cloneDeep(action.data),
        timestamp: Date.now()
      }

    case DATA_SET_DETAILS:

      let detailData = _.cloneDeep(action.data);
      if (Object.keys(detailData).length === 0) {
        detailData = null;
      }
      return {
        ...state,
        details: detailData,
        timestamp: Date.now()
      }

    case DATA_RESET_DETAILS:
      return {
        ...state,
        details: null,
        timestamp: Date.now()
      }

    default:
      return state
  }
}

export const getData = () => {
  return dispatch => {
      axios.get(cfg.api.getData)
      .then((response) => {
          dispatch({type: DATA_GET_DATA, data: response.data.data });
      })
      .catch((error) => {
         console.log(error);
         dispatch({type: DATA_GET_DATA, data: []});
      });
  }
}

export const getDetails = (id) => {
  return dispatch => {
      dispatch({type: DATA_RESET_DETAILS});
      axios.get(`${cfg.api.getDetails}${id}`)
      .then((response) => {
          dispatch({type: DATA_SET_DETAILS, data: response.data.data });
      })
      .catch((error) => {
         console.log(error);
         dispatch({type: DATA_RESET_DETAILS});
      });
  }
}

/*
export const resetDetails = () => {
  return dispatch => {
      dispatch({type: DATA_RESET_DETAILS});
  }
}
*/



// WEBPACK FOOTER //
// ./src/reducers/data.js